// source: witbooking/loyalty/shared/tier.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_type_money_pb = require('../../../google/type/money_pb.js');
goog.object.extend(proto, google_type_money_pb);
goog.exportSymbol('proto.witbooking.loyalty.shared.SpentAmountInfo', null, global);
goog.exportSymbol('proto.witbooking.loyalty.shared.TierConditionAmount', null, global);
goog.exportSymbol('proto.witbooking.loyalty.shared.TierConditionInfo', null, global);
goog.exportSymbol('proto.witbooking.loyalty.shared.TierConditionLevel', null, global);
goog.exportSymbol('proto.witbooking.loyalty.shared.TierConditionType', null, global);
goog.exportSymbol('proto.witbooking.loyalty.shared.TransactionsNumberInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.shared.TierConditionLevel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.shared.TierConditionLevel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.shared.TierConditionLevel.displayName = 'proto.witbooking.loyalty.shared.TierConditionLevel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.shared.TierConditionAmount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.shared.TierConditionAmount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.shared.TierConditionAmount.displayName = 'proto.witbooking.loyalty.shared.TierConditionAmount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.shared.TierConditionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.shared.TierConditionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.shared.TierConditionInfo.displayName = 'proto.witbooking.loyalty.shared.TierConditionInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.shared.TransactionsNumberInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.shared.TransactionsNumberInfo.displayName = 'proto.witbooking.loyalty.shared.TransactionsNumberInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.shared.SpentAmountInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.shared.SpentAmountInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.shared.SpentAmountInfo.displayName = 'proto.witbooking.loyalty.shared.SpentAmountInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.shared.TierConditionLevel.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.shared.TierConditionLevel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.shared.TierConditionLevel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.shared.TierConditionLevel.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    amount: (f = msg.getAmount()) && proto.witbooking.loyalty.shared.TierConditionAmount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.shared.TierConditionLevel}
 */
proto.witbooking.loyalty.shared.TierConditionLevel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.shared.TierConditionLevel;
  return proto.witbooking.loyalty.shared.TierConditionLevel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.shared.TierConditionLevel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.shared.TierConditionLevel}
 */
proto.witbooking.loyalty.shared.TierConditionLevel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.loyalty.shared.TierConditionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = new proto.witbooking.loyalty.shared.TierConditionAmount;
      reader.readMessage(value,proto.witbooking.loyalty.shared.TierConditionAmount.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.shared.TierConditionLevel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.shared.TierConditionLevel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.shared.TierConditionLevel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.shared.TierConditionLevel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.loyalty.shared.TierConditionAmount.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.loyalty.shared.TierConditionLevel.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.shared.TierConditionLevel} returns this
 */
proto.witbooking.loyalty.shared.TierConditionLevel.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TierConditionType type = 2;
 * @return {!proto.witbooking.loyalty.shared.TierConditionType}
 */
proto.witbooking.loyalty.shared.TierConditionLevel.prototype.getType = function() {
  return /** @type {!proto.witbooking.loyalty.shared.TierConditionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.loyalty.shared.TierConditionType} value
 * @return {!proto.witbooking.loyalty.shared.TierConditionLevel} returns this
 */
proto.witbooking.loyalty.shared.TierConditionLevel.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional TierConditionAmount amount = 3;
 * @return {?proto.witbooking.loyalty.shared.TierConditionAmount}
 */
proto.witbooking.loyalty.shared.TierConditionLevel.prototype.getAmount = function() {
  return /** @type{?proto.witbooking.loyalty.shared.TierConditionAmount} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.shared.TierConditionAmount, 3));
};


/**
 * @param {?proto.witbooking.loyalty.shared.TierConditionAmount|undefined} value
 * @return {!proto.witbooking.loyalty.shared.TierConditionLevel} returns this
*/
proto.witbooking.loyalty.shared.TierConditionLevel.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.shared.TierConditionLevel} returns this
 */
proto.witbooking.loyalty.shared.TierConditionLevel.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.shared.TierConditionLevel.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.shared.TierConditionAmount.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.shared.TierConditionAmount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.shared.TierConditionAmount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.shared.TierConditionAmount.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionsNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
    spentAmount: (f = msg.getSpentAmount()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.shared.TierConditionAmount}
 */
proto.witbooking.loyalty.shared.TierConditionAmount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.shared.TierConditionAmount;
  return proto.witbooking.loyalty.shared.TierConditionAmount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.shared.TierConditionAmount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.shared.TierConditionAmount}
 */
proto.witbooking.loyalty.shared.TierConditionAmount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTransactionsNumber(value);
      break;
    case 2:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setSpentAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.shared.TierConditionAmount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.shared.TierConditionAmount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.shared.TierConditionAmount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.shared.TierConditionAmount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionsNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSpentAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 transactions_number = 1;
 * @return {number}
 */
proto.witbooking.loyalty.shared.TierConditionAmount.prototype.getTransactionsNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.shared.TierConditionAmount} returns this
 */
proto.witbooking.loyalty.shared.TierConditionAmount.prototype.setTransactionsNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.type.Money spent_amount = 2;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.loyalty.shared.TierConditionAmount.prototype.getSpentAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 2));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.loyalty.shared.TierConditionAmount} returns this
*/
proto.witbooking.loyalty.shared.TierConditionAmount.prototype.setSpentAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.shared.TierConditionAmount} returns this
 */
proto.witbooking.loyalty.shared.TierConditionAmount.prototype.clearSpentAmount = function() {
  return this.setSpentAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.shared.TierConditionAmount.prototype.hasSpentAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.shared.TierConditionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.shared.TierConditionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.shared.TierConditionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.shared.TierConditionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionsNumber: (f = msg.getTransactionsNumber()) && proto.witbooking.loyalty.shared.TransactionsNumberInfo.toObject(includeInstance, f),
    spentAmount: (f = msg.getSpentAmount()) && proto.witbooking.loyalty.shared.SpentAmountInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.shared.TierConditionInfo}
 */
proto.witbooking.loyalty.shared.TierConditionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.shared.TierConditionInfo;
  return proto.witbooking.loyalty.shared.TierConditionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.shared.TierConditionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.shared.TierConditionInfo}
 */
proto.witbooking.loyalty.shared.TierConditionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.shared.TransactionsNumberInfo;
      reader.readMessage(value,proto.witbooking.loyalty.shared.TransactionsNumberInfo.deserializeBinaryFromReader);
      msg.setTransactionsNumber(value);
      break;
    case 2:
      var value = new proto.witbooking.loyalty.shared.SpentAmountInfo;
      reader.readMessage(value,proto.witbooking.loyalty.shared.SpentAmountInfo.deserializeBinaryFromReader);
      msg.setSpentAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.shared.TierConditionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.shared.TierConditionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.shared.TierConditionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.shared.TierConditionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionsNumber();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.shared.TransactionsNumberInfo.serializeBinaryToWriter
    );
  }
  f = message.getSpentAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.loyalty.shared.SpentAmountInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional TransactionsNumberInfo transactions_number = 1;
 * @return {?proto.witbooking.loyalty.shared.TransactionsNumberInfo}
 */
proto.witbooking.loyalty.shared.TierConditionInfo.prototype.getTransactionsNumber = function() {
  return /** @type{?proto.witbooking.loyalty.shared.TransactionsNumberInfo} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.shared.TransactionsNumberInfo, 1));
};


/**
 * @param {?proto.witbooking.loyalty.shared.TransactionsNumberInfo|undefined} value
 * @return {!proto.witbooking.loyalty.shared.TierConditionInfo} returns this
*/
proto.witbooking.loyalty.shared.TierConditionInfo.prototype.setTransactionsNumber = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.shared.TierConditionInfo} returns this
 */
proto.witbooking.loyalty.shared.TierConditionInfo.prototype.clearTransactionsNumber = function() {
  return this.setTransactionsNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.shared.TierConditionInfo.prototype.hasTransactionsNumber = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SpentAmountInfo spent_amount = 2;
 * @return {?proto.witbooking.loyalty.shared.SpentAmountInfo}
 */
proto.witbooking.loyalty.shared.TierConditionInfo.prototype.getSpentAmount = function() {
  return /** @type{?proto.witbooking.loyalty.shared.SpentAmountInfo} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.shared.SpentAmountInfo, 2));
};


/**
 * @param {?proto.witbooking.loyalty.shared.SpentAmountInfo|undefined} value
 * @return {!proto.witbooking.loyalty.shared.TierConditionInfo} returns this
*/
proto.witbooking.loyalty.shared.TierConditionInfo.prototype.setSpentAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.shared.TierConditionInfo} returns this
 */
proto.witbooking.loyalty.shared.TierConditionInfo.prototype.clearSpentAmount = function() {
  return this.setSpentAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.shared.TierConditionInfo.prototype.hasSpentAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.shared.TransactionsNumberInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.shared.TransactionsNumberInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    validated: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pending: jspb.Message.getFieldWithDefault(msg, 2, 0),
    total: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.shared.TransactionsNumberInfo}
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.shared.TransactionsNumberInfo;
  return proto.witbooking.loyalty.shared.TransactionsNumberInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.shared.TransactionsNumberInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.shared.TransactionsNumberInfo}
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValidated(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPending(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.shared.TransactionsNumberInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.shared.TransactionsNumberInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValidated();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPending();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 validated = 1;
 * @return {number}
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo.prototype.getValidated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.shared.TransactionsNumberInfo} returns this
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo.prototype.setValidated = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 pending = 2;
 * @return {number}
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo.prototype.getPending = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.shared.TransactionsNumberInfo} returns this
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo.prototype.setPending = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 total = 3;
 * @return {number}
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.shared.TransactionsNumberInfo} returns this
 */
proto.witbooking.loyalty.shared.TransactionsNumberInfo.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.shared.SpentAmountInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.shared.SpentAmountInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    validated: (f = msg.getValidated()) && google_type_money_pb.Money.toObject(includeInstance, f),
    pending: (f = msg.getPending()) && google_type_money_pb.Money.toObject(includeInstance, f),
    total: (f = msg.getTotal()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.shared.SpentAmountInfo}
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.shared.SpentAmountInfo;
  return proto.witbooking.loyalty.shared.SpentAmountInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.shared.SpentAmountInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.shared.SpentAmountInfo}
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setValidated(value);
      break;
    case 2:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setPending(value);
      break;
    case 3:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.shared.SpentAmountInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.shared.SpentAmountInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValidated();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getPending();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.type.Money validated = 1;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.getValidated = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 1));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.loyalty.shared.SpentAmountInfo} returns this
*/
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.setValidated = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.shared.SpentAmountInfo} returns this
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.clearValidated = function() {
  return this.setValidated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.hasValidated = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.type.Money pending = 2;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.getPending = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 2));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.loyalty.shared.SpentAmountInfo} returns this
*/
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.setPending = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.shared.SpentAmountInfo} returns this
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.clearPending = function() {
  return this.setPending(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.hasPending = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.type.Money total = 3;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.getTotal = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 3));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.loyalty.shared.SpentAmountInfo} returns this
*/
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.setTotal = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.shared.SpentAmountInfo} returns this
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.clearTotal = function() {
  return this.setTotal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.shared.SpentAmountInfo.prototype.hasTotal = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * @enum {number}
 */
proto.witbooking.loyalty.shared.TierConditionType = {
  EMPTY: 0,
  SPENT_AMOUNT: 1,
  TRANSACTIONS_AMOUNT: 2
};

goog.object.extend(exports, proto.witbooking.loyalty.shared);
